(function () {
  'use strict';
  if (globalThis.JEDesignRetention) return;
  const dialog = document.querySelector('[data-design-retention]');
  const configNode = document.getElementById('DesignRetentionConfig');
  if (!dialog || !configNode || typeof dialog.showModal !== 'function' || globalThis.Shopify?.designMode) return;
  const config = JSON.parse(configNode.textContent), adapters = new Map();
  const $ = selector => dialog.querySelector(selector);
  const translationEntities = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", '#39': "'", '#x27': "'" };
  const strings = Object.fromEntries(Object.entries(config.strings || {}).map(([key, value]) => [key, String(value).replace(/&(amp|lt|gt|quot|apos|#39|#x27);/gi, (_, entity) => translationEntities[entity.toLowerCase()])]));
  const t = key => strings[key] || key;
  const DISMISS = 'jax:design-retention-dismissed:v1', PENDING = 'jax:design-retention-login:v1';
  const TTL = 60 * 60 * 1000, UUID = /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i;
  const PRODUCT_PATH = /^\/(?:[a-z]{2}(?:-[A-Za-z]{2})?\/)?products\/[a-z0-9][a-z0-9-]{0,254}$/;
  let selected, destination, lastFocus, operation = false, allowed = false, pointerDown = false, composing = false;
  let session, sessionPromise, client, resuming = false, resumed = false, dismissed = false, retryCheckpoint, activityVersion = 0, savedContext = {};
  try { dismissed = Number(sessionStorage.getItem(DISMISS)) > Date.now(); } catch {}
  const clientFor = () => client || (client = new EngravingDesignLibrary.Client(config.proxyUrl));
  const error = key => { $('[data-retention-error]').textContent = t(key); $('[data-retention-error]').hidden = false; };
  const clearError = () => { $('[data-retention-error]').hidden = true; $('[data-retention-status]').textContent = ''; };
  const remember = () => { dismissed = true; try { sessionStorage.setItem(DISMISS, String(Date.now() + 24 * 60 * 60 * 1000)); } catch {} };
  async function authenticate(force = false) {
    if (force) { session = null; sessionPromise = null; }
    if (session) return session;
    if (!sessionPromise) sessionPromise = Promise.resolve().then(() => clientFor().request('session')).then(result => {
      if (client.accountKey && client.accountKey !== result.accountKey) { client.assets.clear(); client.attempts.clear(); }
      client.accountKey = result.accountKey || null;
      return (session = result);
    }).catch(() => null).finally(() => { sessionPromise = null; });
    return sessionPromise;
  }
  function store(mode, callback) {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('jax-personalization-drafts', 1);
      request.onupgradeneeded = () => request.result.createObjectStore('drafts');
      request.onerror = request.onblocked = () => reject(new Error('storage'));
      request.onsuccess = () => {
        const db = request.result, tx = db.transaction('drafts', mode), table = tx.objectStore('drafts');
        let value;
        try { value = callback(table); } catch (problem) { db.close(); reject(problem); return; }
        tx.oncomplete = () => { db.close(); resolve(value?.result); };
        tx.onerror = tx.onabort = () => { db.close(); reject(new Error('storage')); };
      };
    });
  }
  async function cleanExpired() {
    await store('readwrite', table => {
      const request = table.openCursor();
      request.onsuccess = () => { const cursor = request.result; if (cursor) { if (!cursor.value?.expiresAt || cursor.value.expiresAt <= Date.now()) cursor.delete(); cursor.continue(); } };
    });
  }
  async function checkpoint(snapshot) {
    const files = snapshot.files || [];
    if (new Blob([JSON.stringify(snapshot)]).size > 32 * 1024 * 1024) throw new Error('too_large');
    if (files.length > 16 || files.some(entry => !(entry.file instanceof Blob) || entry.file.size > 10 * 1024 * 1024) || files.reduce((sum, entry) => sum + entry.file.size, 0) > 20 * 1024 * 1024) throw new Error('too_large');
    const token = crypto.randomUUID(), record = { snapshot, expiresAt: Date.now() + TTL, requestId: crypto.randomUUID() };
    await cleanExpired();
    await store('readwrite', table => table.put(record, token));
    try {
      const previous = sessionStorage.getItem(PENDING);
      sessionStorage.setItem(PENDING, token);
      if (previous && UUID.test(previous)) await store('readwrite', table => table.delete(previous));
    }
    catch { await store('readwrite', table => table.delete(token)); throw new Error('storage'); }
    return { token, record };
  }
  function setBusy(value) {
    operation = value;
    dialog.setAttribute('aria-busy', String(value));
    dialog.querySelectorAll('button').forEach(button => { button.disabled = value; });
    $('[data-retention-save]').textContent = t(value ? 'saving' : 'sign_in_save');
    if (!value && dialog.open && (!dialog.contains(document.activeElement) || !$('[data-retention-saved]').hidden)) $('[data-retention-close]').focus({ preventScroll: true });
  }
  function show(adapter, leave) {
    if (dialog.open || operation) return false;
    selected = adapter; destination = leave || null; lastFocus = document.activeElement;
    clearError();
    $('[data-retention-title]').textContent = t('title');
    $('[data-retention-description]').textContent = t('description');
    $('[data-retention-invitation]').hidden = false;
    $('[data-retention-saved]').hidden = true;
    $('[data-retention-leave]').hidden = !leave;
    const title = adapter?.context?.()?.productTitle || config.productTitle;
    $('[data-retention-product]').textContent = title || '';
    $('[data-retention-product]').hidden = !title;
    dialog.showModal();
    remember();
    return true;
  }
  function close() {
    if (operation) return;
    destination = null;
    dialog.close();
    if (lastFocus?.isConnected) lastFocus.focus({ preventScroll: true });
  }
  function saved(context = {}) {
    savedContext = { ...savedContext, ...context };
    context = savedContext;
    if (!dialog.open) { lastFocus = document.activeElement; dialog.showModal(); }
    clearError(); remember();
    $('[data-retention-title]').textContent = t('saved_title');
    $('[data-retention-description]').textContent = t('saved_description');
    $('[data-retention-invitation]').hidden = true;
    $('[data-retention-saved]').hidden = false;
    const title = context.productTitle || config.productTitle;
    $('[data-retention-product]').textContent = title || '';
    $('[data-retention-product]').hidden = !title;
    const id = String(context.productId || config.productId || '');
    const route = new URL(location.href), designId = context.designId || route.searchParams.get('personalization_saved_draft') || route.searchParams.get('studio_saved_design');
    if (UUID.test(designId || '')) {
      if (dialog.dataset.savedDesign !== designId) { dialog.dataset.savedDesign = designId; dialog.dataset.savedAt = String(Math.floor(Date.now() / 1000)); }
      if (document.querySelector('engraving-studio')) {
        route.searchParams.set('studio_saved_design', designId);
        history.replaceState(history.state, '', route.href);
      }
    }
    $('[data-retention-tags]').value = 'newsletter, design-save' + (/^[1-9]\d{0,23}$/.test(id) ? ', product-interest-' + id : '') + (UUID.test(designId || '') ? ', je-design-' + dialog.dataset.savedAt + '-' + designId : '');
    const discount = $('[data-retention-discount]');
    if (discount) {
      const url = new URL(discount.href), returnTo = new URL(location.pathname, location.origin), current = new URL(location.href);
      for (const key of ['variant', 'view', 'personalization_saved_draft', 'studio_saved_design']) if (current.searchParams.has(key)) returnTo.searchParams.set(key, current.searchParams.get(key));
      url.searchParams.set('redirect', returnTo.pathname + returnTo.search); discount.href = url.href;
    }
    $('[data-retention-close]').focus({ preventScroll: true });
  }
  function eligible(entry) {
    const adapter = entry.adapter;
    if (!entry.element.isConnected || !entry.touched || !adapter.hasWork?.() || adapter.busy?.() || adapter.authenticated?.() || config.authenticated || session?.authenticated) return false;
    if (!adapter.save && !adapter.nativeDocument && session?.capabilities?.personalizationDrafts !== true) return false;
    return true;
  }
  function visibleOverlay(node) {
    if (node === dialog || !node.isConnected || node.closest('[hidden], [inert], [aria-hidden="true"], details:not([open])')) return false;
    if (typeof node.checkVisibility === 'function' && !node.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true, contentVisibilityAuto: true })) return false;
    for (let current = node; current; current = current.parentElement) {
      const style = getComputedStyle(current);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || style.contentVisibility === 'hidden' || Number(style.opacity) === 0) return false;
    }
    const view = globalThis.visualViewport, left = view?.offsetLeft || 0, top = view?.offsetTop || 0;
    const right = left + (view?.width || innerWidth), bottom = top + (view?.height || innerHeight);
    return [...node.getClientRects()].some(rect => rect.width > 0 && rect.height > 0 && rect.right > left && rect.bottom > top && rect.left < right && rect.top < bottom);
  }
  function candidate() {
    if (allowed || dismissed || operation || document.hidden || resuming || composing || pointerDown) return null;
    if ([...document.querySelectorAll('dialog[open], [aria-modal="true"], .drawer.active, .epop.is-visible')].some(visibleOverlay)) return null;
    return [...adapters.values()].find(eligible)?.adapter;
  }
  function activity(event) {
    if (dialog.contains(event.target)) return;
    for (const entry of adapters.values()) {
      if (entry.element.contains(event.target)) {
        activityVersion++;
        entry.touched = true;
        authenticate();
        break;
      }
    }
  }
  async function uploadSnapshot(snapshot) {
    if (!PRODUCT_PATH.test(snapshot.sourcePath) || !/^[1-9]\d{0,23}$/.test(snapshot.productId) || !/^[1-9]\d{0,23}$/.test(snapshot.variantId)) throw new Error('invalid');
    const doc = { kind: 'personalization-draft', version: 1, productId: snapshot.productId, variantId: snapshot.variantId,
      productTitle: (snapshot.productTitle || '').slice(0, 240), sourcePath: snapshot.sourcePath, editor: snapshot.editor,
      fields: snapshot.fields || [], structure: snapshot.structure || {}, assets: [], files: [] };
    for (const [index, entry] of (snapshot.files || []).entries()) {
      const asset = await clientFor().upload(entry.file);
      if (!doc.assets.some(item => item.assetId === asset.assetId)) doc.assets.push({ id: 'draft-file-' + index, name: entry.file.name, mime: entry.file.type, assetId: asset.assetId });
      doc.files.push({ key: entry.key, index: entry.index || 0, assetId: asset.assetId });
    }
    return doc;
  }
  async function persist(record, token) {
    const native = record.snapshot.editor === 'logo-mockup' && record.snapshot.document?.kind === 'engraving-studio';
    if (!session?.authenticated || !native && session.capabilities?.personalizationDrafts !== true) throw new Error('authentication_required');
    if (record.accountKey && record.accountKey !== session.accountKey) throw new Error('account_changed');
    if (!record.input) {
      record.accountKey = session.accountKey;
      await store('readwrite', table => table.put(record, token));
      const document = native ? await clientFor().compact(record.snapshot.document, asset => {
        const bytes = Uint8Array.from(atob(asset.original.split(',')[1]), char => char.charCodeAt(0));
        return new File([bytes], asset.name, { type: asset.mime });
      }) : await uploadSnapshot(record.snapshot);
      record.input = { expectedRevision: 0, name: (record.snapshot.productTitle || t('draft_name')).slice(0, 120), document };
      await store('readwrite', table => table.put(record, token));
    }
    clientFor().attempts.set('save:' + JSON.stringify(record.input), record.requestId);
    const result = await clientFor().request('save', record.input);
    if (result.design?.kind !== (native ? 'engraving-studio' : 'personalization-draft')) throw new Error('unconfirmed');
    await store('readwrite', table => table.delete(token));
    sessionStorage.removeItem(PENDING);
    const url = new URL(location.href); url.searchParams.delete('personalization_resume'); url.searchParams.set('personalization_saved_draft', result.design.id); url.searchParams.set('variant', record.snapshot.variantId); history.replaceState(history.state, '', url.href);
    saved({ ...record.snapshot, designId: result.design.id });
    return result;
  }
  async function saveSelected() {
    if (!selected || operation) return;
    setBusy(true); clearError();
    let navigating = false;
    try {
      if (selected.save) {
        const result = await selected.save();
        if (result?.saved) saved(selected.context?.());
        else if (!result?.navigating) throw new Error('save_failed');
        navigating = result?.navigating === true;
      } else {
        if (!retryCheckpoint || retryCheckpoint.adapter !== selected || retryCheckpoint.version !== activityVersion) {
          const snapshot = await selected.capture();
          retryCheckpoint = { ...await checkpoint(snapshot), adapter: selected, version: activityVersion };
        }
        const { token, record } = retryCheckpoint;
        const verified = await authenticate(true);
        if (!verified || !selected.nativeDocument && verified.capabilities?.personalizationDrafts !== true) throw new Error('unavailable');
        if (verified.authenticated) await persist(record, token);
        else {
          const login = new URL(config.loginUrl, location.origin), back = new URL(location.href);
          back.searchParams.set('personalization_resume', token);
          back.searchParams.set('variant', record.snapshot.variantId);
          login.searchParams.set('return_to', back.pathname + back.search);
          allowed = true; navigating = true;
          location.assign(login.href);
        }
      }
    } catch (problem) { error(problem.message === 'storage' ? 'storage_error' : 'save_error'); }
    finally { if (!navigating) setBusy(false); }
  }
  async function expandedSnapshot(result, adapter) {
    const snapshot = result.design?.document;
    if (adapter.nativeDocument && snapshot?.kind === 'engraving-studio') {
      return { editor: 'logo-mockup', productId: snapshot.productId, variantId: snapshot.variantId, productTitle: snapshot.productTitle,
        sourcePath: location.pathname, document: await clientFor().expand(result), structure: { version: 1, quantity: 1 }, files: [], fields: [] };
    }
    if (snapshot?.kind !== 'personalization-draft' || !PRODUCT_PATH.test(snapshot.sourcePath) || snapshot.sourcePath !== location.pathname || String(snapshot.productId) !== String(config.productId)) throw new Error('invalid');
    const expanded = await clientFor().expand(result);
    return { ...snapshot, files: (snapshot.files || []).map(reference => {
      const index = snapshot.assets.findIndex(asset => asset.assetId === reference.assetId), asset = expanded.assets[index];
      if (!asset?.original) throw new Error('invalid');
      const binary = atob(asset.original.split(',')[1]), bytes = Uint8Array.from(binary, char => char.charCodeAt(0));
      return { key: reference.key, index: reference.index, file: new File([bytes], asset.name, { type: asset.mime }) };
    }) };
  }
  async function resume(entry) {
    const url = new URL(location.href), token = url.searchParams.get('personalization_resume'), id = url.searchParams.get('personalization_saved_draft');
    if (resuming || resumed || (!token && !id) || !entry.adapter.restore) return;
    resuming = true;
    const wasInert = entry.element.inert, previousBusy = entry.element.getAttribute('aria-busy');
    entry.element.inert = true; entry.element.setAttribute('aria-busy', 'true');
    let opened = false;
    try {
      const verified = await authenticate();
      if (!verified) throw new Error('unavailable');
      if (token) {
        if (!UUID.test(token) || token !== sessionStorage.getItem(PENDING)) throw new Error('invalid');
        const record = await store('readonly', table => table.get(token));
        if (!record || record.expiresAt <= Date.now() || record.snapshot.sourcePath !== location.pathname) throw new Error('invalid');
        await entry.adapter.restore(record.snapshot);
        entry.touched = true; resumed = true;
        retryCheckpoint = { token, record, adapter: entry.adapter, version: activityVersion };
        if (verified.authenticated) { await persist(record, token); opened = true; }
        else { selected = entry.adapter; opened = show(selected); error('signin_incomplete'); }
      } else {
        if (!UUID.test(id) || !verified.authenticated) throw new Error('authentication_required');
        const snapshot = await expandedSnapshot(await clientFor().request('get', { id }), entry.adapter);
        await entry.adapter.restore(snapshot);
        resumed = true; entry.touched = false;
      }
    } catch { opened = show(entry.adapter); error('restore_error'); }
    finally {
      entry.element.inert = wasInert;
      if (previousBusy === null) entry.element.removeAttribute('aria-busy'); else entry.element.setAttribute('aria-busy', previousBusy);
      resuming = false; if (opened) setBusy(false);
    }
  }
  globalThis.JEDesignRetention = Object.freeze({
    register(element, adapter) {
      const entry = { element, adapter, touched: false };
      adapters.set(element, entry);
      if (new URL(location.href).searchParams.has('personalization_resume') || new URL(location.href).searchParams.has('personalization_saved_draft')) resume(entry);
      return () => adapters.delete(element);
    }
  });
  document.dispatchEvent(new CustomEvent('jax:design-retention-ready'));
  document.dispatchEvent(new CustomEvent('je:retention-ready'));
  document.addEventListener('input', activity, true);
  document.addEventListener('change', activity, true);
  document.addEventListener('pointerdown', event => { pointerDown = true; activity(event); }, true);
  document.addEventListener('pointerup', () => { pointerDown = false; }, true);
  document.addEventListener('pointercancel', () => { pointerDown = false; }, true);
  document.addEventListener('compositionstart', () => { composing = true; }, true);
  document.addEventListener('compositionend', () => { composing = false; }, true);
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || dialog.contains(event.target)) return;
    const link = event.target.closest('a[href]');
    if (!link || link.download || link.hasAttribute('download') || link.target && link.target !== '_self') return;
    const url = new URL(link.href, location.href), here = new URL(location.href);
    if (!['https:', 'http:'].includes(url.protocol) || url.pathname === here.pathname && url.search === here.search || /\/(?:cart|checkouts?|customer_authentication|account)(?:\/|$)/.test(url.pathname)) return;
    if (link.matches('[data-studio-entry-link]') || link.closest('[data-studio-handoff], .studio-handoff, [data-personalization-entry]')) return;
    if (url.origin === here.origin && url.pathname === here.pathname && ['studio-customize', 'live-personalize', 'quick-personalize'].includes(url.searchParams.get('view'))) return;
    const adapter = candidate();
    if (adapter && show(adapter, { url: url.href })) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  globalThis.navigation?.addEventListener('navigate', event => {
    if (event.navigationType !== 'traverse' || !event.cancelable || event.hashChange || event.destination.sameDocument) return;
    const adapter = candidate();
    if (adapter && show(adapter, { key: event.destination.key, url: event.destination.url })) event.preventDefault();
  });
  document.documentElement.addEventListener('mouseleave', event => {
    if (event.clientY > 0 || !matchMedia('(hover: hover) and (pointer: fine)').matches || document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return;
    const adapter = candidate();
    if (adapter) show(adapter);
  });
  dialog.addEventListener('click', event => {
    if (event.target.closest('[data-retention-close]')) close();
    else if (event.target.closest('[data-retention-save]')) saveSelected();
    else if (event.target.closest('[data-retention-leave]') && destination) {
      const leave = destination; allowed = true; selected?.allowLeave?.(); close();
      if (leave.key && globalThis.navigation) navigation.traverseTo(leave.key); else location.assign(leave.url);
    } else if (event.target === dialog) {
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
    }
  });
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const controls = [...dialog.querySelectorAll('button:not(:disabled), a[href], input:not(:disabled)')].filter(node => node.getClientRects().length);
    const first = controls[0], last = controls.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
  document.addEventListener('jax:design-retention-saved', event => saved(event.detail));
  const form = dialog.querySelector('form'), email = $('#DesignSaveEmail');
  let formPending = false, formTimer;
  function resetForm() { formPending = false; form?.removeAttribute('aria-busy'); form?.querySelector('button[type="submit"]')?.removeAttribute('disabled'); clearTimeout(formTimer); }
  form?.addEventListener('submit', event => {
    if (formPending || composing || !email?.validity.valid) {
      event.preventDefault();
      if (!formPending && !composing) { email.setAttribute('aria-invalid', 'true'); $('[data-retention-email-error]').textContent = t('email_error'); $('[data-retention-email-error]').hidden = false; email.focus(); }
      return;
    }
    try { sessionStorage.setItem('jax:design-retention-newsletter', String(Date.now())); } catch {}
    const returnTo = form.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = location.pathname + location.search;
    formPending = true; form.setAttribute('aria-busy', 'true'); form.querySelector('button[type="submit"]').disabled = true;
    formTimer = setTimeout(resetForm, 15000);
  });
  email?.addEventListener('input', () => { email.removeAttribute('aria-invalid'); $('[data-retention-email-error]').hidden = true; });
  globalThis.addEventListener('pageshow', () => { allowed = false; pointerDown = false; setBusy(false); resetForm(); });
  try {
    const posted = Number(sessionStorage.getItem('jax:design-retention-newsletter'));
    if (posted && Date.now() - posted < 15 * 60 * 1000 && ($('[data-retention-newsletter-success]') || !$('[data-retention-email-error]')?.hidden)) {
      sessionStorage.removeItem('jax:design-retention-newsletter'); saved();
    }
  } catch {}
})();
